export default __webpack_public_path__ + "static/media/questions.cd2bd70d.svg";